import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=0f2352d9&"
import script from "./HomeAbout.vue?vue&type=script&lang=js&"
export * from "./HomeAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports